import React from 'react';

const BS_TabsPills = () => {
    return (
        <div>
            <h1>BS_TabsPills Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_TabsPills;
